import React, { useEffect, useState, useRef } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet';
import axios from "axios";

import HomePageContent from "./Pages/HomePageContent";
import ContactPageContent from "./Pages/ContactPageContent";
import Notification from "../Components/Notification";
import Loader from "../Components/Loader/Loader";
import ImageEditor from "../Components/ImageEditor/ImageEditor";
import SingleDeletePage from "../Components/DeleteModal/SingleDeletePage";
import AddCategoryPage from "../Components/Modal/AddCategoryPage";
import UploadMediaPopup from "../Components/Modal/UploadMediaPopup";
import PreviewPopup from "../Components/Modal/PreviewPopup";
import Error from "./Error";

import { dataURLtoFile } from "../utils/functions";

import send from ".././images/send.svg";
import plus from ".././images/plus_author.svg";
import link from ".././images/Settings/link.svg";
import linkExternal from ".././images/link-external.svg";
import coverImg from ".././images/picture.svg";
import featured from ".././images/featured.svg";
import iconDropDown from ".././images/icondropdown.svg";
import dots from ".././images/dots.svg";
import search from ".././images/icon-search.svg";

import ".././App.css";
import NotificationMessage from "../Components/NotificationMessage";
import { EditorComponent } from "../Components/TiptapEditor/Editor";
function convertToSlug(str) {
  // Convert the string to lowercase
  let slug = str.toLowerCase();

  // Remove starting and ending spaces
  slug = slug.trim();

  // Replace special characters except for dash with an empty string
  slug = slug.replace(/[^a-z0-9\s-]/g, '');

  // Replace spaces with a single hyphen "-"
  slug = slug.replace(/\s+/g, '-');

  return slug;
}

function NewPage(props) {
  const fileInputRef = useRef(null);

  const [featureImage, setFeatureImage] = useState(null);
  const [saveFeatureImage, setSaveFeatureImage] = useState(null);
  const [oldImage, setOldImage] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [loadingFeatureImg, setloadingFeatureImg] = useState(false);
  const [replaceImgTimeLoading, setReplaceImgTimeLoading] = useState(false);
  const [featuredImageModal, setFeaturedImageModal] = useState(false);
  const [replcaeImageZoom, setReplcaeImageZoom] = useState(false);
  const modalRef = useRef(null);
  const [zoom, setZoom] = useState(1);
  const [oldZoom, setOldZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0.5, y: 0.5 });
  const [isDragging, setIsDragging] = useState(false);
  const [isSlugChanged, setIslugChanged] = useState(false);
  const [pageTitle, setPageTitle] = useState('');
  const [status, setStatus] = useState("");
  const [dbPageTitle, setdbPageTitle] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isDraftLoading, setIsDraftLoading] = useState(false);
  const [isPreviewLoading, setPreviewLoading] = useState(false);
  const [validateTitle, setValidateTitle] = useState(false);
  const [validateEditorContent, setValidateEditorContent] = useState(false);
  const [validateImage, setValidateImage] = useState(false);
  const [apiCall, setApiCall] = useState(false);
  const [openPagePopup, setOpenPagePopup] = useState(false);
  const [popupData, setPopupData] = useState({url_address: '', pageImage: ''});

  const [isHomepage, setIsHomepage] = useState(false);
  const [isContactpage, setIsContactpage] = useState(false);
  const [showPublication, setShowPublication] = useState(false);
  const [homepageData, setHomepageData] = useState({});
  const [contactpageData, setContactpageData] = useState({});
  const [updatedContactpageData, setUpdatedContactpageData] = useState({
    pageText: '',
    publicAddress: '',
    publicEmail: '',
    showSocialNetwork: false,
    showContactForm: false,
    toReceiveEmail: '',
    phoneNumber: {
      dialCode: '91',
      countryCode: 'in',
      phoneNumber: '',
      value: ''
    },
    featured_image: {}
  });
  const [validationContactpageData, setValidationContactpageData] = useState({
    publicEmailValid : true,
    receiveEmailValid: true,
    showError: false,
    publicaPhoneValid: true,
  });

  
  const [showUploadMediaPopup, setShowUploadMediaPopup] = useState(false);
  const [uploadMediaPopupFor, setUploadMediaPopupFor] = useState('');
  const [uploadMediaPopupTab, setUploadMediaPopupTab] = useState('upload');
  const [selectedFeatureImage, setSelectedFeatureImage] = useState('');
  const [selectMediaLoading, setSelectMediaLoading] = useState(false);
  const [selectedFeatureImageData, setSelectedFeatureImageData] = useState('');
  const [featureImageUrl, setFeatureImageUrl] = useState("");
  const [isFormInvalid, setIsFormInvalid] = useState(true);
  const [previewErrorMessage, setPreviewErrorMessage] = useState('');

  const [featureCropedImageId, setFeatureCropedImageId] = useState('');
  const [featureImageId, setFeatureImageId] = useState('');

  // Start Search
  const [values, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [showCategoryField, setShowCategoryField] = useState(false);
  const [searchCategory, setSearchCategory] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const [canAccess, setCanAccess] = useState(true);
  const [canChkAccess, setCanChkAccess] = useState(false);

  const [openNotify, setOpenNotify] = useState(false);
  const [openNotifyDraft, setOpenNotifyDraft] = useState(false);

  const [published, setPublished] = useState(false);
  const [draft, setDraft] = useState(false);
  const [isDraftOpen, setIsDraftOpen] = useState(false);
  const [isPublishedOpen, setIsPublishedOpen] = useState(false);
  const [pageImage, setPageImage] = useState('');
  const [data, setData] = useState([]);
  const [draftNotify, setDraftNotify]= useState(false)
  const [categoriesNotify, setCategoriesNotify] = useState(false)
  const [customDomain, setCustomDomain] = useState({})
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [imageCaption, setimageCaption] = useState();
  const [selectedImageCaption, setSelectedImageCaption] = useState('');

  const dotsRef = useRef(null);

  const profileSlug = localStorage.getItem('userProfileSlug');

  let baseUrl ;

  if (props?.userMetaData?.customDomain?.verified === true) {
    baseUrl = `${props?.userMetaData?.customDomain?.domain}/`;
  } else {
    baseUrl = `https://jourmal-next-front.vercel.app/${profileSlug}/`;
  }
  
  var notificationTimeoutId = '';

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search);
  const statusValue = queryParams.get("status");

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if(statusValue === "published"){
        setOpenNotify(false);
        setOpenPagePopup(true);
    }
  },[statusValue])

  const fetchData = async () => {
    try {
      const categoriesData = await axios.get(
        `${process.env.REACT_APP_API_URL}/categories/list/${JSON.parse(localStorage.getItem("userinfo"))?._id}`,
      );
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/user/${JSON.parse(localStorage.getItem("userinfo"))?._id}`,
      )
      setCustomDomain(response?.data?.result?.userMeta?.customDomain)
      if( categoriesData.status == 200 ) {        
        const categoriesArray = categoriesData.data.result.map(item => item.name);
        setCategories(categoriesArray);
      }
      
    } catch (error) {
      console.log(error, "error");
    }
  }

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        (!modalRef.current.contains(event.target) &&
          featuredImageModal === false) ||
        event.target.className === "overlayModal"
      ) {
        setFeaturedImageModal(false);
        setZoom(oldZoom);
        setOldImage(newUploadedImage);
      }
    };

    if (featuredImageModal) {
      window.addEventListener("click", handleOutsideClick);
    }

    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, [featuredImageModal]);

  const [isOpen1, setIsOpen1] = useState(true);
  const [isOpen3, setIsOpen3] = useState(true);
  const [isOpen4, setIsOpen4] = useState(true);

  const toggleDropdown1 = () => {
    setIsOpen1(!isOpen1);
  };

  const toggleDropdown3 = () => {
    setIsOpen3(!isOpen3);
  };

  const toggleDropdown4 = () => {
    setIsOpen4(!isOpen4);
  };

  const [uploadedImage, setUploadedImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [newUploadedImage, setNewUploadedImage] = useState(null);

  // props.setActivePage("Page");

  const [editorContent, setEditorContent] = useState("");
  const [updatedContent, setUpdatedContent] = useState("");

  const [url, setUrl] = useState("");

  const [allPublicationList, setAllPublicationList] = useState([]);

  const [origPublicationList, setOrigPublicationList] = useState([]);

  useEffect(() => {
    if( isHomepage ) {
        setUrl("");
    }

    if( isContactpage ) {
        setUrl("contact");
    }
},[isHomepage, isContactpage])

  useEffect(() => {
    setOrigPublicationList(allPublicationList);
  }, [allPublicationList]);

  const [publicationList, setPublicationList] = useState([]);

  const [selectPublication, setSelectPublication] = useState(false);

  const [publicationInput, setPublicationInput] = useState("");

  useEffect(() => {
    if (publicationInput.length === 0) {
      setOrigPublicationList(allPublicationList);
    } else {
      var result = [];
      var input = publicationInput.toLowerCase();
      origPublicationList.forEach((element) => {
        var title = element.title.toLowerCase();

        if (title) {
          if (title.startsWith(input) === true) {
            result.push(element);
          }
        }
      });

      if (result != []) {
        setOrigPublicationList(result);
      } else {
        setOrigPublicationList([]);
      }
    }
  }, [publicationInput]);
  const ref = useRef();

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (selectPublication && ref.current && !ref.current.contains(e.target)) {
        setSelectPublication(false);
        setIsDraftOpen(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [selectPublication]);

  useEffect(() => {
    if(selectedFeatureImage !== '') {
      setBlobData();
      setSelectedImageCaption(selectedFeatureImage?.description || "")
    }
    
  }, [selectedFeatureImage]);

  const setBlobData = async () => {
    setSelectMediaLoading(true);
    try {
      const imageData = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/fetchImageData/${JSON.parse(localStorage.getItem("userinfo"))?._id}`,
        selectedFeatureImage,
        { responseType: 'blob' }
      );
      
      const imageUrl = URL.createObjectURL(imageData.data);

      setZoom(1);

      setUploadedImage(imageUrl);
      setImageFile(null);
      setOldImage(imageUrl);

      if(featureImage === null || featureImage === '') {
        setFeatureImage(imageUrl);
      }

      setloadingFeatureImg(false);
      setFeaturedImageModal(true);
      setReplcaeImageZoom(false);

      setPageImage(imageUrl);

      setSelectedFeatureImageData(selectedFeatureImage);

      setSelectMediaLoading(false);
      setShowUploadMediaPopup(false);
      setUploadMediaPopupFor('');

    } catch (error) {
      setSelectMediaLoading(false);
      console.log({error:error, message: error.message})
    }
    setSelectMediaLoading(false);
  }

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (e.target != null && isPublishedOpen && (!e.target.classList.contains('publish-li') && !e.target.classList.contains('newpageMoreButtons'))) {
        setIsPublishedOpen(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isPublishedOpen]);

  const handleClick = () => {
    setFeaturedImageModal(!featuredImageModal);
    // setFeatureImage(saveFeatureImage);
    var divElement = document.getElementById("newpageImageUpload");
    divElement.classList.add("imageUploaded");
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
    if (!isDragging) {
      setIsDragging(true);
    }
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    var divElement = document.getElementById("newpageImageUpload");

    var extraHeight = (featureImage) ? 2 : 0;

    divElement.style.height = (divElement.clientHeight + extraHeight) + "px";
    divElement.style.minHeight = (divElement.clientHeight + extraHeight) + "px";

    divElement.classList.remove("imageUploaded");
    setloadingFeatureImg(true);

    var TempReplcaeImageZoom = replcaeImageZoom
    var TempReplaceImgTimeLoading = replaceImgTimeLoading

    if (featureImage) {
      setReplcaeImageZoom(true);
      setReplaceImgTimeLoading(false);

      TempReplcaeImageZoom = true;
      TempReplaceImgTimeLoading = false;
    }

    if (TempReplcaeImageZoom === true) {
      setOldZoom(1);
      setZoom(1);
    } else {
      setZoom(oldZoom);
    }

    e.preventDefault();
    const file = e.dataTransfer.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.src = reader.result;
      img.onload = () => {
        if (file) {
          setUploadedImage(file);
          setImageFile(file);
          setPageImage(file);
          TempReplcaeImageZoom !== true && setFeatureImage(reader.result);
          setOldImage(reader.result);
        }
      };
    };
    if (file) {      
      setPageImage(file);
      setTimeout(() => {
        reader.readAsDataURL(file);
        setDragging(false);
        setUploadedImage(file);
        setImageFile(file);
        setloadingFeatureImg(false);
        var divElement = document.getElementById("newpageImageUpload");
        divElement.classList.add("imageUploaded");
        divElement.classList.add("imageUploaded-wrap");
        setOldImage(file);
        setFeaturedImageModal(true);
        setReplcaeImageZoom(false);
        setReplaceImgTimeLoading(false);

        // divElement.style.height = 'auto';
        // divElement.style.minHeight = 'unset';
      }, 4000);
    } else {
      setloadingFeatureImg(false);

      // divElement.style.height = 'auto';
      // divElement.style.minHeight = 'unset';
    }
    setIsDragging(false);
  };

  const handleFileUpload = (e) => {
    var divElement = document.getElementById("newpageImageUpload");

    var extraHeight = (featureImage) ? 2 : 0;

    divElement.style.height = (divElement.clientHeight + extraHeight) + "px";
    divElement.style.minHeight = (divElement.clientHeight + extraHeight) + "px";

    divElement.classList.remove("imageUploaded");
    setloadingFeatureImg(true);
    if (replcaeImageZoom === true) {
      setOldZoom(1);
      setZoom(1);
    } else {
      setZoom(oldZoom);
    }
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const image = new Image();
      image.src = reader.result;
      image.onload = () => {
        replcaeImageZoom !== true && setFeatureImage(reader.result);
        setOldImage(reader.result);
      };
    };
    if (file) {
      reader.readAsDataURL(file);

      setUploadedImage(null);
      setImageFile(null);
      setPageImage(file);

      setTimeout(() => {
        reader.readAsDataURL(file);
        setDragging(false);
        setloadingFeatureImg(false);
        setUploadedImage(file);
        setImageFile(file);
        var divElement = document.getElementById("newpageImageUpload");
        divElement.classList.add("imageUploaded");
        divElement.classList.add("imageUploaded-wrap");
        setFeaturedImageModal(true);
        setReplcaeImageZoom(false);

        // divElement.style.height = 'auto';
        // divElement.style.minHeight = 'unset';
      }, 4000);
    } else {
      setloadingFeatureImg(false);
      // divElement.style.height = 'auto';
      // divElement.style.minHeight = 'unset';
    }
  };

  const handleImageLoad = () => {
    const img = new Image();
    img.src = featureImage;
    img.onload = () => { };
  };

  const handleReplaceImg = () => {
    // document.getElementById("feature-img").click();
    setShowUploadMediaPopup(true);
    setUploadMediaPopupFor('feature-image');
    setFeaturedImageModal(false);
    setReplcaeImageZoom(true);
    setReplaceImgTimeLoading(false);
  };

  useEffect(() => {
    setZoom(zoom);
  }, [zoom]);

  const handleZoom = (zoom) => {
    setZoom(zoom);
  };

  const handlePosition = (newPosition) => {
    setPosition(newPosition);
  };

  const handleSavePicture = async () => {
    let click = document.getElementById("clickFunction");
    click.click();
    setFeatureImage(featureImage);
    setNewUploadedImage(oldImage);
    setSaveFeatureImage(featureImage);
    setFeaturedImageModal(false);
    setOldZoom(zoom);
    if(selectedImageCaption !== undefined && selectedImageCaption !== null && selectedImageCaption !== ""){
      setimageCaption(selectedImageCaption)
    }
    props?.setContentChange(true)
    setHasUnsavedChanges(true); 
  };

  const handleMouseDown = () => {
    const slider = document.getElementById("zoom-range");
    slider.classList.add("slider-cursor");
  };

  const handleMouseUp = () => {
    const slider = document.getElementById("zoom-range");
    slider.classList.remove("slider-cursor");
  };

  const handleTouchStart = () => {
    const slider = document.getElementById("zoom-range");
    slider.classList.add("slider-cursor");
  };

  const handleTouchEnd = () => {
    const slider = document.getElementById("zoom-range");
    slider.classList.remove("slider-cursor");
  };

  const handleCancel = () => {
    if (!saveFeatureImage) {
      var divElement = document.getElementById("newpageImageUpload");
      featureImage && divElement.classList.remove("imageUploaded");
    } else {
      var divElement = document.getElementById("newpageImageUpload");
      featureImage && divElement.classList.add("imageUploaded");
    }
    setOldImage(newUploadedImage);
    setFeaturedImageModal(false);
    setZoom(oldZoom);

    if (fileInputRef.current) {
      fileInputRef.current.value = null;
      setUploadedImage(null);
      setImageFile(null);
    }
  };

  const changeSlug = (value) => {
    // setPageTitle(value);
    if (!isSlugChanged) {
      let urlValue = convertToSlug(value);
      setUrl(urlValue);
    }
  }

  const changeTitle = (e) => {
    //Stop enter button

    if (e.key === 'Enter') {
      e.preventDefault();
      return true;
    }

  }

  const changesTitles = (e) => {
    const text = e.target.innerText.replace(/<[^>]+>/g, '');

    if (text.length <= 120 || e.key === 'Backspace') {
      // setPageTitle(text)
      changeSlug(text);
    } else {
      e.preventDefault();
      return true;
    }
  }

  const handleBlur = (e) => {
    const text = e.target.innerText.replace(/<[^>]+>/g, '').trim();
    setdbPageTitle(text)
  }

  const handlePaste = (e) => {
    setHasUnsavedChanges(true);
    props?.setContentChange(true); 
    e.preventDefault();

    // Get the plain text content from clipboard
    const clipboardData = e.clipboardData.getData('text/plain');

    // Paste the plain text into the contenteditable div
    document.execCommand('insertText', false, clipboardData);
  }
  const [authorId, setauthorId] = useState(JSON.parse(localStorage.getItem("userinfo"))?._id);

  const { id } = useParams()
  const [newPageID, setNewPageID] = useState( null );

  useEffect(() => {

    const user_id = JSON.parse(localStorage.getItem("userinfo"))?._id
    const homagepage_id = btoa(`homepage-${user_id}`);
    const contactpage_id = btoa(`contactpage-${user_id}`);

    if( homagepage_id ===  id) {
      setIsHomepage(true);
      setPublished(true);
      setStatus('Published')
    }

    if( contactpage_id ===  id) {
      setIsContactpage(true);
      setPublished(true);
      setStatus('Published')
    }

    setCanChkAccess(true);
    setNewPageID(id);
  }, [id]);

  useEffect(() => {
    if(canChkAccess) {
      if (id) {
        singlePageList()
      } else {
        setEditorContent('')
        setUpdatedContent('')
        setdbPageTitle('')
        setUrl('')
        setPublicationList([])
        setIsLoading(false)
        setFeatureImage('')
        setDraft(false)
        setPublished(false)
        setIsDraftLoading(false)
        setSaveFeatureImage(null)

        setSelectedCategories([])
      }
      clearTimeout(notificationTimeoutId)
    }
  }, [isHomepage, isContactpage, canChkAccess,id]);

    const [showNotification, setShowNotification] = useState(false);
    

  const singlePageList = async () => {
    try {
        const userId = JSON.parse(localStorage.getItem("userinfo"))?._id;
        if (isHomepage) {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/user/getHomepage/${userId}`);
            if (res) {
                let homepagedata = res?.data?.result?.homePageData;
                console.log(res?.data)
                setHomepageData(homepagedata);
                setimageCaption(homepagedata?.image_caption)
                setCanAccess(true);

                setEditorContent(homepagedata.summary); 
                setUpdatedContent(homepageData.summary)               

                if (res?.data?.homepageMedia?.selectedMedia) {
                  const imageData = await axios.post(
                      `${process.env.REACT_APP_API_URL}/user/fetchImageData/${userId}`,
                      res?.data?.homepageMedia?.selectedMedia,
                      { responseType: 'blob' }
                  );

                  const imageUrl = URL.createObjectURL(imageData.data);
                  setUploadedImage(imageUrl);
                  setImageFile(null);
                  setNewUploadedImage(imageUrl);
                  setOldImage(imageUrl);
                  setFeatureImageId(res?.data?.homepageMedia?.selectedMedia);
                }

                if (res?.data?.homepageMedia?.cropedMedia) {
                  const imageData = await axios.post(
                      `${process.env.REACT_APP_API_URL}/user/fetchImageData/${userId}`,
                      res?.data?.homepageMedia?.cropedMedia,
                      { responseType: 'blob' }
                  );

                  const imageUrl = URL.createObjectURL(imageData.data);

                  setFeatureImage(imageUrl);
                  setSaveFeatureImage(imageUrl);
                  setFeatureCropedImageId(res?.data?.homepageMedia?.cropedMedia);

                  setPageImage(imageUrl);

                  setPopupData(prevState => ({
                    ...prevState,
                    url_address: '',
                    pageImage: imageUrl
                  }));
                }
                if(homepagedata?.featured_image?.zoom) {
                  setZoom(homepagedata.featured_image.zoom)
                  setOldZoom(homepagedata.featured_image.zoom)
                }        
                if(homepagedata?.featured_image?.position) {
                  setPosition(homepagedata.featured_image.position)
                }
            }
        } else if (isContactpage) {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/user/getContactpage/${userId}`);
            if (res) {
                let contactpagedata = res?.data?.result;
                console.log({contactpagedata})
                setContactpageData(contactpagedata);
                setimageCaption(contactpagedata?.userMeta?.image_caption)
                setCanAccess(true);

                if (contactpagedata?.userMeta?.featured_image?.selectedImage) {
                  const imageData = await axios.post(
                      `${process.env.REACT_APP_API_URL}/user/fetchImageData/${userId}`,
                      contactpagedata.constactMedia.selectedMedia,
                      { responseType: 'blob' }
                  );

                  const imageUrl = URL.createObjectURL(imageData.data);
                  setUploadedImage(imageUrl);
                  setImageFile(null);
                  setNewUploadedImage(imageUrl);
                  setOldImage(imageUrl);
                  setFeatureImageId(contactpagedata.userMeta.featured_image.selectedImage);
                }

                if (contactpagedata?.userMeta?.featured_image?.cropedImage) {
                  const imageData = await axios.post(
                      `${process.env.REACT_APP_API_URL}/user/fetchImageData/${userId}`,
                      contactpagedata.constactMedia.cropedMedia,
                      { responseType: 'blob' }
                  );

                  const imageUrl = URL.createObjectURL(imageData.data);

                  setFeatureImage(imageUrl);
                  setSaveFeatureImage(imageUrl);
                  setFeatureCropedImageId(contactpagedata.userMeta.featured_image.cropedImage);

                  setPageImage(imageUrl);

                  setPopupData(prevState => ({
                    ...prevState,
                    url_address: 'contact',
                    pageImage: imageUrl
                  }));
                }       

                if(contactpagedata?.userMeta?.featured_image?.zoom) {
                  setZoom(contactpagedata.userMeta.featured_image.zoom)
                  setOldZoom(contactpagedata.userMeta.featured_image.zoom)
                }  

                if(contactpagedata?.userMeta?.featured_image?.position) {
                  setPosition(contactpagedata.userMeta.featured_image.position)
                }
            }
        } else {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/pages/${id}?userId=${userId}`);
            if (res) {
              const pageData = res?.data?.result;
              setdbPageTitle(pageData.title);
              setStatus(pageData.status);
              setEditorContent(pageData.description === "<p></p>" ? "" : pageData.description);
              setUpdatedContent(pageData.description === "<p></p>" ? "" : pageData.description);
              setUrl(pageData.url_address);
              setFeatureImageUrl(res?.data?.result?.featureImageUrl);
              setData(pageData);
              setimageCaption(res?.data?.result?.image_caption)

              setPopupData(prevState => ({
                ...prevState,
                url_address: pageData.url_address,
                pageImage: res?.data?.result?.featureImageUrl
              }));

              if (pageData.status === "Published") {
                  setPublished(true);
              }
              if (pageData.status === "Draft") {
                  setDraft(true);
              }

              let publicationListData = [];
              let selectedCat = [];
              pageData.categories?.forEach((item) => {
                  publicationListData.push({ title: item });
                  selectedCat.push(item);
              });

              if (pageData?.featured_image?.selectedImage) {
                  const imageData = await axios.post(
                      `${process.env.REACT_APP_API_URL}/user/fetchImageData/${userId}`,
                      pageData.featureImageData.selectedMedia,
                      { responseType: 'blob' }
                  );

                  const imageUrl = URL.createObjectURL(imageData.data);
                  setUploadedImage(imageUrl);
                  setImageFile(null);
                  setNewUploadedImage(imageUrl);
                  setOldImage(imageUrl);
                  setFeatureImageId(pageData.featured_image.selectedImage);
              }
              if (pageData?.featured_image?.cropedImage) {
                const imageData = await axios.post(
                    `${process.env.REACT_APP_API_URL}/user/fetchImageData/${userId}`,
                    pageData.featureImageData.cropedMedia,
                    { responseType: 'blob' }
                );

                const imageUrl = URL.createObjectURL(imageData.data);

                setFeatureImage(imageUrl);
                setSaveFeatureImage(imageUrl);
                setFeatureCropedImageId(pageData.featured_image.cropedImage);

                setPageImage(imageUrl);
              }
              if(pageData?.featured_image?.zoom) {
                setZoom(pageData.featured_image.zoom)
                setOldZoom(pageData.featured_image.zoom)
              }
      
              if(pageData?.featured_image?.position) {
                setPosition(pageData.featured_image.position)
              }

              setPublicationList(publicationListData);
              setSelectedCategories(selectedCat);
              setCanAccess(true);
            } else {
                setCanAccess(false);
            }
        }
    } catch (err) {
        setCanAccess(false);
        console.log(err);
    }
}

  const handleChangeToDraft = async () => {
    if (published) {
      setIsLoading(true)
      let selectedImage = featureImageId;
      let featureCropedImage = featureCropedImageId;

      const featureImageData = await getFeatureImageData(newPageID)

      selectedImage = featureImageData?.selectedImage || selectedImage;
      featureCropedImage = featureImageData?.featureCropedImage || featureCropedImage;

      const newPageData = {
        description: updatedContent || editorContent,
        title: dbPageTitle,
        author_id: authorId,
        url_address: url,
        categories: selectedCategories,
        status: "Draft",
        previous_status: "Draft",
        featured_image: {
          selectedImage: selectedImage,
          cropedImage: featureCropedImage,
          position: position,
          zoom: zoom
        },
        image_caption: imageCaption,
        tempData: {
          description: updatedContent || editorContent,
          title: dbPageTitle,
          author_id: authorId,
          url_address: url,
          categories: selectedCategories,
          status: "Draft",
          previous_status: "Draft",
          featured_image: {
            selectedImage: selectedImage,
            cropedImage: featureCropedImage,
            position: position,
            zoom: zoom
          },
          pageTitle: dbPageTitle,
          postContent: updatedContent || editorContent,
          pageImage: featureCropedImage,
          image_caption: imageCaption,
        }
      }
      await axios.post(
        `${process.env.REACT_APP_API_URL}/pages/updatepage/${newPageID}`,
        newPageData
      )
        .then((res) => {
          setIsLoading(false)
        })
        .catch((err) => {
          setIsLoading(false)
        })
        props?.setContentChange(false)
        setHasUnsavedChanges(false); 

      setOpenNotifyDraft(true)
      //close the popup

      clearTimeout(notificationTimeoutId) 
      notificationTimeoutId = setTimeout(() => {
        setOpenNotifyDraft(false)
      }, 10000);
      setPublished(false);
      setDraft(true);
      setIsPublishedOpen(false);
      setIsDraftOpen(false);
      setStatus("Draft")
    }
  };

  const handleChangeToPublish = async () => {
    setIsLoading(true)
    let selectedImage = featureImageId;
    let featureCropedImage = featureCropedImageId;

    const featureImageData = await getFeatureImageData(newPageID)

    selectedImage = featureImageData?.selectedImage || selectedImage;
    featureCropedImage = featureImageData?.featureCropedImage || featureCropedImage;
    const newPageData = {
      description: updatedContent||  editorContent,
      title: dbPageTitle,
      author_id: authorId,
      url_address: url,
      categories: selectedCategories,
      status: 'Published',
      previous_status: 'Published',
      featured_image: {
        selectedImage: selectedImage,
        cropedImage: featureCropedImage,
        position: position,
        zoom: zoom
      },
      image_caption: imageCaption,
    }
     await axios.post(
      `${process.env.REACT_APP_API_URL}/pages/updatepage/${newPageID}`,
      newPageData
    )
      .then((res) => {
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false)
      })
      props?.setContentChange(false)
      setHasUnsavedChanges(false);
      setOpenPagePopup(true) 
      setOpenNotify(false);
    setPublished(true);
    setDraft(false);
    setIsPublishedOpen(false);
    setIsDraftOpen(false);
    setStatus("Published")
    setPopupData(prevState => ({
      ...prevState,
      url_address: url,
      pageImage: featureImageData?.url
    }));

    clearTimeout(notificationTimeoutId)

  };

  const [isPopupOpenDeleteAccount, setIsPopupOpenDeleteAccount] = useState(false);

  const handelSingleDelete = () => {
    setIsDraftOpen(false);
    setIsPublishedOpen(false);
    setIsPopupOpenDeleteAccount(true);
    document.body.classList.add('hidden-message');
  }

  const closeAccountDeletedPopup = () => {
    setIsPopupOpenDeleteAccount(false);
    document.body.classList.remove('hidden-message');
  }

  const closeCategoryField = (action) => {
    
    setShowCategoryField(false);
    document.body.classList.remove('hidden-message');

    setTimeout(() => {
      scrollToBottom();
    }, 100);
  }

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (e.target != null && isPopupOpenDeleteAccount && (e.target.classList.contains('welcomeOverlay'))) {
        setIsPopupOpenDeleteAccount(false);
      }

      if (e.target != null && isDraftOpen && !(e.target.classList.contains('publishedButtonsList')) && !(e.target.classList.contains('publish-li'))) {
        setIsDraftOpen(false);
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isPopupOpenDeleteAccount, isDraftOpen]);

  const handleDraft = async () => {

    if (apiCall === false) {
      draftValidateFields();
      setIsLoading(true)
      setApiCall(true)

      let selectedImage = featureImageId;
      let featureCropedImage = featureCropedImageId;

      const featureImageData = await getFeatureImageData(newPageID)

      selectedImage = featureImageData?.selectedImage || selectedImage;
      featureCropedImage = featureImageData?.featureCropedImage || featureCropedImage;

      const newPageData = {
        description: updatedContent || editorContent,
        title: dbPageTitle,
        author_id: authorId,
        url_address: url,
        categories: selectedCategories,
        status: "Draft",
        previous_status: "Draft",
        featured_image: {
          selectedImage: selectedImage,
          cropedImage: featureCropedImage,
          position: position,
          zoom: zoom
        },
        image_caption: imageCaption,
        tempData: {
          description: updatedContent || editorContent,
          title: dbPageTitle,
          author_id: authorId,
          url_address: url,
          categories: selectedCategories,
          status: "Draft",
          previous_status: "Draft",
          featured_image: {
            selectedImage: selectedImage,
            cropedImage: featureCropedImage,
            position: position,
            zoom: zoom
          },
          pageTitle: dbPageTitle,
          postContent: updatedContent || editorContent,
          pageImage: featureCropedImage,
          image_caption: imageCaption,
        }
      }
      await axios.post(
        `${process.env.REACT_APP_API_URL}/pages/updatepage/${newPageID}`,
        newPageData
      )
        .then((res) => {
          setIsLoading(false)
          setOpenNotifyDraft(true)
          
          clearTimeout(notificationTimeoutId)
          notificationTimeoutId = setTimeout(() => {
            setOpenNotifyDraft(false)
          }, 10000);
          
          if (isLoading === false) {
            setApiCall(false)
          }
        })
        .catch((err) => {
          setIsLoading(false)
          if (isLoading === false) {
            setApiCall(false)
          }
        })
        props?.setContentChange(false)
        setHasUnsavedChanges(false); 
    }
  }

  const handlePublish = async () => {

    if (apiCall === false) {
      setIsLoading(true)
      setApiCall(true)

      let selectedImage = featureImageId;
      let featureCropedImage = featureCropedImageId;

      const featureImageData = await getFeatureImageData(newPageID)

      selectedImage = featureImageData?.selectedImage || selectedImage;
      featureCropedImage = featureImageData?.featureCropedImage || featureCropedImage;
      
      const newPageData = {
        description: updatedContent || editorContent,
        title: dbPageTitle,
        author_id: authorId,
        url_address: url,
        categories: selectedCategories,
        status: 'Published',
        previous_status: 'Published',
        featured_image: {
          selectedImage: selectedImage,
          cropedImage: featureCropedImage,
          position: position,
          zoom: zoom
        },
        image_caption: imageCaption,
        tempData: {
          description: updatedContent || editorContent,
          title: dbPageTitle,
          author_id: authorId,
          url_address: url,
          categories: selectedCategories,
          status: "Published",
          previous_status: "Published",
          featured_image: {
            selectedImage: selectedImage,
            cropedImage: featureCropedImage,
            position: position,
            zoom: zoom
          },
          pageTitle: dbPageTitle,
          postContent: updatedContent || editorContent,
          pageImage: featureCropedImage,
          image_caption: imageCaption,
        }
      }

      if( isHomepage ) {
        const homepageData = {
          summary: updatedContent || editorContent,
          showPublication:showPublication,
          featured_image: {
            selectedImage: selectedImage,
            cropedImage: featureCropedImage,
            position: position,
            zoom: zoom
          },
          image_caption: imageCaption,
          tempData: {
            author_id: authorId,
            url_address: url,
            summary: updatedContent || editorContent,
            postSummary: updatedContent || editorContent,
            showPublication:showPublication,
            featured_image: {
              selectedImage: selectedImage,
              cropedImage: featureCropedImage,
              position: position,
              zoom: zoom
            },
            image_caption: imageCaption,
          }
        };
        await axios.post(
            `${process.env.REACT_APP_API_URL}/user/updateHomepage/${JSON.parse(localStorage.getItem("userinfo"))?._id}`,
            homepageData
        ).then((res) => {
          setOpenNotify(true)
          setIsLoading(false)
          if (isLoading === false) {
            setApiCall(false)
          }
          
          clearTimeout(notificationTimeoutId) 
          notificationTimeoutId = setTimeout(() => {
            setOpenNotify(false)
          }, 10000);
        })
        .catch((error) => {
          if (isLoading === false) {
            setApiCall(false)
          }
          setIsLoading(false)
        });
        props?.setContentChange(false)
        setHasUnsavedChanges(false); 
      }

      if( isContactpage ) {
        const contactpageData = {
          ...updatedContactpageData,
          featured_image: {
            selectedImage: selectedImage,
            cropedImage: featureCropedImage,
            position: position,
            zoom: zoom
          },
          image_caption: imageCaption,
          tempData: {
            ...updatedContactpageData,
            featured_image: {
              selectedImage: selectedImage,
              cropedImage: featureCropedImage,
              position: position,
              zoom: zoom
            },
            image_caption: imageCaption,
          }
        }

        
        await axios.post(
          `${process.env.REACT_APP_API_URL}/user/updateContactpage/${JSON.parse(localStorage.getItem("userinfo"))?._id}`,
          contactpageData
        ).then((res) => {
          setOpenNotify(true)
          setIsLoading(false)
          
          if (isLoading === false) {
            setApiCall(false)
          }
          
          clearTimeout(notificationTimeoutId) 
            notificationTimeoutId = setTimeout(() => {
              setOpenNotify(false)
            }, 10000);
          })
          .catch((error) => {
            if (isLoading === false) {
              setApiCall(false)
            }
            setIsLoading(false)
          });
          props?.setContentChange(false)
          setHasUnsavedChanges(false); 
      }

      if( ! isHomepage && ! isContactpage ) {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/pages/updatepage/${newPageID}`,
          newPageData
        )
          .then((res) => {
            setOpenNotify(true)
            setIsLoading(false)
            
            setStatus('Published');
            
            if (isLoading === false) {
              setApiCall(false)
            }
            
            clearTimeout(notificationTimeoutId) 
            notificationTimeoutId = setTimeout(() => {
              setOpenNotify(false)
            }, 10000);
          })
          .catch((error) => {
            if (isLoading === false) {
              setApiCall(false)
            }
            setIsLoading(false)
          })
          props?.setContentChange(false)
          setHasUnsavedChanges(false); 
        }

    }
  }

  const handleChangeURL = (pageID) => {
    const newUrl = '/dashboard/page/' + pageID;  // Replace with the URL you want

    // Change the URL without reloading the page
    window.history.pushState({}, '', newUrl);
  };

  const addData = async (isDraft, status) => {
    if (id) {
      try {
        
        let selectedImage = featureImageId;
        let featureCropedImage = featureCropedImageId;

        const featureImageData = await getFeatureImageData(id)

        selectedImage = featureImageData?.selectedImage || selectedImage;
        featureCropedImage = featureImageData?.featureCropedImage || featureCropedImage;
        
        const newPageData = {
          description: updatedContent || editorContent,
          title: dbPageTitle,
          author_id: authorId,
          url_address: url,
          categories: selectedCategories,
          status: status,
          previous_status: status,
          featured_image: {
            selectedImage: selectedImage,
            cropedImage: featureCropedImage,
            position: position,
            zoom: zoom
          },
          image_caption: imageCaption,
          tempData: {
            description: updatedContent || editorContent,
            title: dbPageTitle,
            author_id: authorId,
            url_address: url,
            categories: selectedCategories,
            status: status,
            previous_status: status,
            featured_image: {
              selectedImage: selectedImage,
              cropedImage: featureCropedImage,
              position: position,
              zoom: zoom
            },
            pageTitle: dbPageTitle,
            postContent: updatedContent || editorContent,
            pageImage: featureCropedImage,
            image_caption: imageCaption,
          }
        }
        await axios.post(
          `${process.env.REACT_APP_API_URL}/pages/updatepage/${id}`,
          newPageData
        )
        if(status === 'Published'){
          setOpenPagePopup(true) 
          setOpenNotify(false);
          setPopupData(prevState => ({
            ...prevState,
            url_address: url,
            pageImage: featureImageData?.url
          }));
        }
        props?.setContentChange(false)
        setHasUnsavedChanges(false); 

        clearTimeout(notificationTimeoutId) 
        notificationTimeoutId = setTimeout(() => {
          setOpenNotify(false)
        }, 15000);
      } catch (error) {
        setIsDraftLoading(false);
        setIsLoading(false);
      }
    } else {
      try {
        const newPageData = {
          description: updatedContent || editorContent,
          title: dbPageTitle,
          author_id: authorId,
          url_address: url,
          categories: selectedCategories,
          status: status,
          previous_status: status,
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/pages/addpage`,
          newPageData
        );

        if (response.status = 201) {
          const _pageId = response.data.result._id;
          handleChangeURL(_pageId);
          setNewPageID(_pageId);
          
          let selectedImage = featureImageId;
          let featureCropedImage = featureCropedImageId;

          const featureImageData = await getFeatureImageData(_pageId)

          selectedImage = featureImageData?.selectedImage || selectedImage;
          featureCropedImage = featureImageData?.featureCropedImage || featureCropedImage;

          const updatedPageData = { 
            ...newPageData, 
            featured_image: {
              selectedImage: selectedImage,
              cropedImage: featureCropedImage,
              position: position,
              zoom: zoom
            },
            image_caption: imageCaption,
            tempData: {
              description: updatedContent || editorContent,
              title: dbPageTitle,
              author_id: authorId,
              url_address: url,
              categories: selectedCategories,
              status: status,
              previous_status: status,
              featured_image: {
                selectedImage: selectedImage,
                cropedImage: featureCropedImage,
                position: position,
                zoom: zoom
              },
              pageTitle: dbPageTitle,
              postContent: updatedContent || editorContent,
              pageImage: featureCropedImage,
              image_caption: imageCaption,
            }
          };
          await axios.post(
            `${process.env.REACT_APP_API_URL}/pages/updatepage/${_pageId}`,
            updatedPageData
          )
          props?.setContentChange(false)
          setHasUnsavedChanges(false); 
          if(status === 'Published'){
            setOpenPagePopup(true) 
            setOpenNotify(false);
            setPopupData(prevState => ({
              ...prevState,
              url_address: url,
              pageImage: featureImageData?.url
            }));
          }
        }    
        setIsLoading(false);
        if(response.status === 200){
          if (status === "Draft") {
            setOpenNotifyDraft(true)
            
            clearTimeout(notificationTimeoutId) 
            notificationTimeoutId = setTimeout(() => {
              setOpenNotifyDraft(false)
            }, 10000);
          }
        }
        setIsDraftLoading(false);

      } catch (error) {
        setIsDraftLoading(false);
        setIsLoading(false);
      }
    }
  }

  const getFeatureImageData = async (id,preview) => {
    let selectedImage = featureImageId;
    let featureCropedImage = featureCropedImageId;
    let url = ''
    
    if( imageFile !== null ) {  
          const imageFormData = new FormData();
          imageFormData.append('files', imageFile); // Append each file individually
          try {
            const res = await axios.post(
              `${process.env.REACT_APP_API_URL}/user/uploadMedia/${JSON.parse(localStorage.getItem("userinfo"))?._id}`,
              imageFormData, {
                  headers: {
                      'Content-Type': 'multipart/form-data'
                  }
              }
            );          
            selectedImage = res.data.result[0]._id;
            url = res.data.result[0]?.url
    
            const featureImageFile = await dataURLtoFile(featureImage, "feature-image.jpg");
            const featureImageFileTemp = await dataURLtoFile(featureImage, "temp-feature-image.jpg");
            const formData = new FormData();
            if(preview === 'preview'){
              formData.append('files', featureImageFileTemp);
            } else {
              formData.append('files', featureImageFile);
            }
            formData.append('id', id);
            const uploadedMedia = await axios.post(
              `${process.env.REACT_APP_API_URL}/user/uploadMedia/${JSON.parse(localStorage.getItem("userinfo"))?._id}`,
              formData, {
                  headers: {
                      'Content-Type': 'multipart/form-data'
                  }
              }
            );
  
            featureCropedImage = uploadedMedia?.data?.result[0]?._id || featureCropedImage;
  
          } catch (error) {
            console.log(error);
          }
          //(featureImageId !== '' || selectedFeatureImageData?._id) && oldImage !== saveFeatureImage
        } else if((selectedFeatureImageData?._id) || oldImage !== saveFeatureImage) {        
        const formData = new FormData();
          const featureImageFile = await dataURLtoFile(featureImage, "feature-image.jpg");
          const featureImageFileTemp = await dataURLtoFile(featureImage, "temp-feature-image.jpg");
          if(preview === 'preview'){
            formData.append('files', featureImageFileTemp);
          } else {
            formData.append('files', featureImageFile);
          }
          formData.append('id', id);
  
          const uploadedMedia = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/uploadMedia/${JSON.parse(localStorage.getItem("userinfo"))?._id}`,
        formData, {
          headers: {
                    'Content-Type': 'multipart/form-data'
                }
        }
          );
  
          selectedImage = selectedFeatureImageData?._id || selectedImage;
          featureCropedImage = uploadedMedia?.data?.result[0]?._id || featureCropedImage;
          url = uploadedMedia?.data?.result[0]?.url
      }
      
    const result = {selectedImage, featureCropedImage,url}
      
    return result;
  }

  const validateFields = () => {
    if (pageTitle.length > 0) {
      setValidateTitle(false);
    } else {
      setValidateTitle(true);
    }
    if (dbPageTitle.length > 0) {
      setValidateTitle(false);
    } else {
      setValidateTitle(true);
    }
    if ((updatedContent?.trim().length > 0 || editorContent?.trim().length > 0)) {
      setValidateEditorContent(false);
    } else {
      setValidateEditorContent(true);
    }
    if (pageImage === '') {
      setValidateImage(true);
    } else {
      setValidateImage(false);
    }
  }

  const draftValidateFields = () => {
    if (pageTitle.length > 0) {
      setValidateTitle(false);
    } else {
      setValidateTitle(true);
    }
    if (dbPageTitle.length > 0) {
      setValidateTitle(false);
    } else {
      setValidateTitle(true);
    }
    setPreviewLoading(false)
  }

  useEffect(() => {
    // Use the effect to clear the error message after 2 seconds
    const timer = setTimeout(() => {
      setErrorMessage('');
    }, 2000); 

    return () => {
      clearTimeout(timer);
    };
  }, [errorMessage]);
  
  
  const handleCheckboxChange = (value) => {
    props?.setContentChange(true)
    setHasUnsavedChanges(true); 
    if (selectedCategories.includes(value)) {
      setSelectedCategories(selectedCategories.filter((v) => v !== value));
    } else {
      setSelectedCategories([...selectedCategories, value]);
    }
  };

  const filteredValues = values.filter((value) =>
    value.toLowerCase().includes(searchCategory.toLowerCase())
  );

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && inputValue.trim() !== '') {      
      setSearchCategory(inputValue);
      setInputValue('');
    }
  };

  const handleNewCategoryClick = () => {
    // setInputValue(''); // Clear input when creating a new category
    setShowCategoryField(true); // Hide closeLink    
    // setErrorMessage('');
    document.body.classList.add('hidden-message');
  };

  // Function to scroll the ul to the bottom
  const scrollToBottom = () => {
    var categoriesList = document.querySelector('.categories-list');
    var liElements = categoriesList.querySelectorAll('li');

    let totalHeight = ( ( parseInt( liElements.length ) + 1 ) * 22 ) + 5;

    categoriesList.scrollTop = totalHeight;
  };

  // End Search
  useEffect(() => {
    if (featuredImageModal) {
        const handleKeyDown = (e) => {
            const deleteMediaElement = document.getElementById('deleteMedia');
            if (e?.key === 'Enter' && featuredImageModal && deleteMediaElement?.children?.length > 0) {
              handleSavePicture()
            }else if(e?.key === "Escape"){
                setShowUploadMediaPopup(false)
                handleCancel()

            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }
}, [featuredImageModal]);


const showPreview = async () => {
  
  let canShowPreview = false;
    if (isContactpage || isHomepage) {
      if(pageImage !== '') {
        canShowPreview = true;
      }
    }else {
      if((dbPageTitle.length > 0 && ((editorContent?.length > 0) || (updatedContent?.length > 0)) && pageImage !== '')) {
        canShowPreview = true;
      }
    }

    if( ! canShowPreview ) {
      setPreviewLoading(false)
      return false;
    }

    let _pageId;
    let sendStatus;
    setPreviewLoading(true)
    if ((!newPageID) || (newPageID === undefined)) {
      setPreviewLoading(true)
      validateFields();
      if(dbPageTitle.length > 0 && ((editorContent?.length > 0) || (updatedContent?.length > 0)) && pageImage !== ''){
        setPreviewLoading(true)
        let selectedImage = featureImageId;
        let featureCropedImage = featureCropedImageId;

        const featureImageData = await getFeatureImageData(newPageID,'preview')

        selectedImage = featureImageData?.selectedImage || selectedImage;
        featureCropedImage = featureImageData?.featureCropedImage || featureCropedImage;
        const newPageData = {
          description: updatedContent || editorContent,
          title: dbPageTitle,
          author_id: authorId,
          url_address: url,
          categories: selectedCategories,
          status: 'Draft',
          previous_status: status,
          featured_image: {
            selectedImage: selectedImage,
            cropedImage: featureCropedImage,
            position: position,
            zoom: zoom
          }
        }

  
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/pages/addpage`,
          newPageData
        );

        if (response.status === 200) {
          _pageId = response.data.result._id;
          sendStatus = response.data.result.status;
          handleChangeURL(_pageId);
          setNewPageID(_pageId);
  
          let selectedImage = featureImageId;
          let featureCropedImage = featureCropedImageId;
  
          const featureImageData = await getFeatureImageData(_pageId,'preview')
  
          selectedImage = featureImageData?.selectedImage || selectedImage;
          featureCropedImage = featureImageData?.featureCropedImage || featureCropedImage;
  
          const updatedPageData = {
            ...newPageData,
            image_caption: imageCaption,
            featured_image: {
              selectedImage: selectedImage,
              cropedImage: featureCropedImage,
              position: position,
              zoom: zoom
            }
          };
          await axios.post(
            `${process.env.REACT_APP_API_URL}/pages/updatepage/${_pageId}`,
            updatedPageData
          )
          setPreviewLoading(false)
          setStatus('Draft')
          setPublished(false);
          setDraft(true);
        }
      } else {
        setPreviewLoading(false)
      }
    }
    
    let selectedImage = featureImageId;
    let featureCropedImage = featureCropedImageId;
    let featureImageData
    if(!isHomepage && !isContactpage){
      if(dbPageTitle.length > 0 && ((editorContent?.length > 0) || (updatedContent?.length > 0)) && pageImage !== '' ){
        featureImageData = await getFeatureImageData(newPageID,'preview')
        selectedImage = featureImageData?.selectedImage || selectedImage;
        featureCropedImage = featureImageData?.featureCropedImage || featureCropedImage;
        setPreviewLoading(true)
      } else {
        setPreviewLoading(false)
      }
    }
    if (isHomepage) {
      featureImageData = await getFeatureImageData(newPageID,'preview')
      selectedImage = featureImageData?.selectedImage || selectedImage;
      featureCropedImage = featureImageData?.featureCropedImage || featureCropedImage;
      const homepageData = {

        tempData: {
          author_id: authorId,
          url_address: url,
          status: sendStatus? sendStatus : status,
          previous_status: sendStatus ? sendStatus : status,
          summary: updatedContent || editorContent,
          postSummary: updatedContent || editorContent,
          showPublication:showPublication,
          featured_image: {
            selectedImage: selectedImage,
            cropedImage: featureCropedImage,
            position: position,
            zoom: zoom
          },
          image_caption: imageCaption
        }
      };
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/updateHomepage/${JSON.parse(localStorage.getItem("userinfo"))?._id}`,
        homepageData
      )
      if (res?.status === 200) {
        setPreviewLoading(false)
        window.open(`https://reactdashboard.codeptsolutions.com/dashboard/previewhome/${JSON.parse(localStorage.getItem("userinfo"))?._id}`, "_blank");
      }
      return;
    }
    if (isContactpage) {
      featureImageData = await getFeatureImageData(newPageID,'preview')
      selectedImage = featureImageData?.selectedImage || selectedImage;
      featureCropedImage = featureImageData?.featureCropedImage || featureCropedImage;
      const contactpageData = {
        tempData: {
          ...updatedContactpageData,
          featured_image: {
            selectedImage: selectedImage,
            cropedImage: featureCropedImage,
            position: position,
            zoom: zoom
          },
          image_caption: imageCaption
        }
      }

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/user/updateContactpage/${JSON.parse(localStorage.getItem("userinfo"))?._id}`,
        contactpageData
      )
      if (res?.status === 200) {
        setPreviewLoading(false)
        window.open(`https://reactdashboard.codeptsolutions.com/dashboard/previewcontact/${JSON.parse(localStorage.getItem("userinfo"))?._id}`, "_blank");
      }
      return false;
    }

    if ((!isHomepage && !isContactpage)) {
      const newPageData = {
        tempData: {
          description: updatedContent || editorContent,
          title: dbPageTitle,
          author_id: authorId,
          url_address: url,
          categories: selectedCategories,
          status: sendStatus ? sendStatus : status,
          previous_status: sendStatus ? sendStatus : status,
          featured_image: {
            selectedImage: selectedImage,
            cropedImage: featureCropedImage,
            position: position,
            zoom: zoom
          },
          pageTitle: dbPageTitle,
          postContent: updatedContent || editorContent,
          pageImage: featureCropedImage,
          image_caption: imageCaption,
        }
      }
      if (dbPageTitle.length > 0 && ((editorContent?.length > 0) || (updatedContent?.length > 0)) && pageImage !== '') {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/pages/updatepage/${_pageId ? _pageId : newPageID}`,
          newPageData
        )
        if (res?.status === 200) {
          setPreviewLoading(false)
          window.open(`https://reactdashboard.codeptsolutions.com/dashboard/previewpage/${_pageId ? _pageId : newPageID}`, "_blank");
        }
      }else {
        setPreviewLoading(false)
      }
    }else {
      setPreviewLoading(false)
    }

  }
  const validateForm = () => {
    let isValid;
    if(isHomepage || isContactpage){
      isValid = pageImage !== ''
    }else{
      isValid = (dbPageTitle.length > 0 && ((editorContent?.length > 0) || (updatedContent?.length > 0)) && pageImage !== '');
    }
    setIsFormInvalid(!isValid);  // Update the form validation state
  };

  useEffect(() => {
    // Validate form whenever tempData changes
    validateForm();
  }, [dbPageTitle, editorContent, updatedContent, pageImage]);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
        setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
        window.removeEventListener("scroll", handleScroll);
    };
}, []);

const handleContentChange = (newContent) => {
  props?.setContentChange(true)
  setUpdatedContent(newContent);
  setHasUnsavedChanges(true); 
  if (updatedContent?.trim().length > 0 || editorContent?.trim().length > 0) {
    setValidateEditorContent(false);
  } else {
    setValidateEditorContent(true);
  }
};

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasUnsavedChanges) {
        const confirmLeave = window.confirm("Changes you made may not be saved. Are you sure you want to leave?");
        event.returnValue = confirmLeave;
        if (confirmLeave) {
          setHasUnsavedChanges(false)
        }
        return confirmLeave;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  return (
    <>
      {
        canAccess ?            
          <section className="dashboard new-page">
            <Helmet>
                <title>{(newPageID && dbPageTitle.length > 0) ? `${dbPageTitle} | Dashboard | Persone` : "New Page | Dashboard | Persone" }</title>
            </Helmet>
            <div className="container">
              <div className="dashboardTop">
                <div className="newpageContent newpageContentImage">
                  <div className={`newpageLeft ${(isHomepage || isContactpage) ? "homePageContent" : '' }`}>
                    {
                      isHomepage && 
                        <HomePageContent homepageData={homepageData} setEditorContent={setEditorContent} validateEditorContent={validateEditorContent} setValidateEditorContent={setValidateEditorContent} showPublication={showPublication} setShowPublication={setShowPublication}  setActivePage={props.setActivePage} setContentChange={props?.setContentChange} setHasUnsavedChanges={setHasUnsavedChanges}/>
                    }

                    {
                      isContactpage && 
                        <ContactPageContent contactpageData={contactpageData} setUpdatedContactpageData={setUpdatedContactpageData} validationContactpageData={validationContactpageData} setValidationContactpageData={setValidationContactpageData}  setShowUpgradeModel={props?.setShowUpgradeModel} planDetails={props?.planDetails} setActivePage={props.setActivePage} setContentChange={props?.setContentChange} setHasUnsavedChanges={setHasUnsavedChanges}/>
                    }

                    {
                      (! isHomepage && ! isContactpage) && 
                        <>

                        <div className="newpageLeftRow editor-block">
                          <input type="hidden" className="page-title" value={dbPageTitle} onChange={(e) => { changeSlug(e.target.value); props?.setContentChange(true);setHasUnsavedChanges(true);  }} placeholder="Title" />

                          <div id="post-title" placeholder="Title" contentEditable="true"
                            onKeyDown={(e) => {
                              changeTitle(e)
                              if (e.target.innerText.length > 0) {
                                setValidateTitle(false);
                              }
                              setHasUnsavedChanges(true);
                              props?.setContentChange(true);
                            }}
                            onKeyUp={(e) => {
                              
                              changesTitles(e);
                              if (e.target.innerText.length > 0) {
                                setValidateTitle(false);
                                setHasUnsavedChanges(true);
                                props?.setContentChange(true);
                              }
                              if (e.target.innerHTML === "<br>") {
                                e.target.innerHTML = "";
                                setHasUnsavedChanges(false);
                                props?.setContentChange(false);
                              }
                            }}
                            onBlur={(e) => {
                              handleBlur(e);
                              if (e.target.innerHTML === "<br>") {
                                e.target.innerHTML = "";
                              }
                            }}
                            onPaste={(e) => handlePaste(e)} >{dbPageTitle}</div>
                        </div>
                        {validateTitle === true ? (
                          <p className="validateError editor-error editor-error-space">Please enter a title</p>
                        ) : (
                          ""
                        )}

                        <div className={`newpageLeftRow textBlock ${validateEditorContent ? 'validateError inputError' : ''}`}>
                          <EditorComponent setUpdatedContent={handleContentChange} editorContent={editorContent} type="page" id={id} setValidateEditorContent={setValidateEditorContent} setEditorContent={setEditorContent}/>
                        </div>
                        {validateEditorContent && 
                          <p className="validateError editor-error editor-error-space">Please enter a content to the page</p>
                        }

                        </>
                    }

                  </div>
                  <div className={`newpageRight newpageRightSticky`}>
                    <div className={`buttonsDesktop ${scrolled && 'scrolled'}`}>

                      {(published === false && draft === false) ?
                        <div className="newpageRightButtons publish-button">
                          <button
                            className="primary-button minwidthAuto button"
                            onClick={async (e) => {
                              validateFields();
                              if (dbPageTitle.length > 0 && ((updatedContent?.trim().length > 0 || editorContent?.trim().length > 0)) && pageImage !== '') {
                                setIsLoading(true);
                                await addData(true, "Published");
                                setStatus('Published');
                                setOpenNotify(true);
                                setPublished(true);
                                setPublicationList([...publicationList, { title: "Published" }]);

                                clearTimeout(notificationTimeoutId) 
                                notificationTimeoutId = setTimeout(() => {
                                  setOpenNotify(false)
                                }, 10000);
                              }
                            }
                            }
                          >
                            {isLoading ?
                              <div className="publishbutton-loader">
                                <div className="ring-loader"></div>
                              </div>
                              :
                              <>
                                <img src={send} alt="Send" />
                                <p>Publish</p>
                              </>}
                          </button>
                          <button className="secondary-button minwidthAuto button draft-button"
                            onClick={async (e) => {
                              draftValidateFields();
                              if (dbPageTitle.length > 0) {
                                setIsDraftLoading(true);
                                await addData(true, "Draft");
                                setStatus('Draft');
                                setDraft(true);
                                setDraftNotify(true)
                              }
                            }}>
                            {isDraftLoading ?
                              <div className="draftButton-loader">
                                <div className="ring-loader cancel"></div>
                              </div>
                              :
                              <>
                                Save as draft
                              </>}
                          </button>
                          {
                            isPreviewLoading ? 
                            <div className="previewButtonLoader">
                              <div className="ring-loader cancel"></div>
                            </div> 
                            : 
                            <button className={`minwidthAuto secondary-button ${((isHomepage || isContactpage) && pageImage !== '') || 
                              (!isHomepage && !isContactpage && dbPageTitle.length > 0 && 
                                ((editorContent?.length > 0) || (updatedContent?.length > 0)) && pageImage !== '')  ? 'preview-btn previewTooltipblock button' : 'preview-btn  previewTooltipblock preview-disabled'}`} onClick={() => { showPreview() }} onMouseEnter={() => {
                              if (isFormInvalid) {
                                setPreviewErrorMessage("Please fill in all the required fields to preview");
                              }
                            }}
                            onMouseLeave= {() => {
                              setPreviewErrorMessage("");
                            }}>
                              {previewErrorMessage !== "" && <div className='text-tooltip'>{previewErrorMessage}</div>}
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.01677 10.5942C1.90328 10.4145 1.84654 10.3246 1.81477 10.186C1.79091 10.0819 1.79091 9.91775 1.81477 9.81366C1.84654 9.67507 1.90328 9.58522 2.01677 9.40552C2.95461 7.92054 5.74617 4.1665 10.0003 4.1665C14.2545 4.1665 17.0461 7.92054 17.9839 9.40552C18.0974 9.58522 18.1541 9.67507 18.1859 9.81366C18.2098 9.91775 18.2098 10.0819 18.1859 10.186C18.1541 10.3246 18.0974 10.4145 17.9839 10.5942C17.0461 12.0791 14.2545 15.8332 10.0003 15.8332C5.74617 15.8332 2.95461 12.0791 2.01677 10.5942Z" stroke="#344054" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M10.0003 12.4998C11.381 12.4998 12.5003 11.3805 12.5003 9.99984C12.5003 8.61913 11.381 7.49984 10.0003 7.49984C8.61962 7.49984 7.50034 8.61913 7.50034 9.99984C7.50034 11.3805 8.61962 12.4998 10.0003 12.4998Z" stroke="#344054" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              Preview
                            </button>
                          }
                        </div>
                        :
                        ''}

                      {published === true ? (
                        <div>
                          <div className="newpageRightButtons" ref={dotsRef}>
                            <button className="primary-button button updatePagebtn" onClick={(e) => {
                              validateFields();
                              if (dbPageTitle.length > 0 && ((updatedContent?.trim().length > 0 || editorContent?.trim().length > 0)) && pageImage !== '') {
                                handlePublish(e)
                              }
                              if( isHomepage && ((updatedContent?.trim().length > 0 || editorContent?.trim().length > 0)) && pageImage !== '' ) {
                                handlePublish(e)
                              }
                              if( isContactpage && pageImage !== '' ) {

                                if( validationContactpageData.publicEmailValid && validationContactpageData.receiveEmailValid && validationContactpageData.publicaPhoneValid ) {
                                  handlePublish(e);
                                } else {
                                  setValidationContactpageData((prevState) => ({
                                      ...prevState, // Spread the previous state
                                      showError: true // Update showError with the new value
                                  }));
                                }
                              }
                            }}>
                              {isLoading ?
                                <div className="updatebutton-loader">
                                  <div className="ring-loader"></div>
                                </div>
                                :
                                <>
                                  <p>Update</p>
                                </>}
                            </button>
                              
                            
                            
                            <button
                              className="newpageMoreButtons button secondary-button minwidthAuto"
                              onClick={(e) => setIsPublishedOpen(!isPublishedOpen)}
                            >
                              <img src={dots} alt="Dots" className="action-dots" />
                            </button>
                            {
                              isPreviewLoading ? 
                              <div className="previewButtonLoader">
                                <div className="ring-loader cancel"></div>
                              </div> 
                              : 
                              <button className={`secondary-button minwidthAuto ${((isHomepage || isContactpage) && pageImage !== '') || 
                                (!isHomepage && !isContactpage && dbPageTitle.length > 0 && 
                                  ((editorContent?.length > 0) || (updatedContent?.length > 0)) && pageImage !== '')  ? 'preview-btn  previewTooltipblock button' : 'preview-btn  previewTooltipblock preview-disabled'}`} onClick={() => { showPreview() }} onMouseEnter={() => {
                                if (isFormInvalid) {
                                  setPreviewErrorMessage("Please fill in all the required fields to preview");
                                }
                              }}
                              onMouseLeave= {() => {
                                setPreviewErrorMessage("");
                              }}>
                                {previewErrorMessage !== "" && <div className='text-tooltip'>{previewErrorMessage}</div>}
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.01677 10.5942C1.90328 10.4145 1.84654 10.3246 1.81477 10.186C1.79091 10.0819 1.79091 9.91775 1.81477 9.81366C1.84654 9.67507 1.90328 9.58522 2.01677 9.40552C2.95461 7.92054 5.74617 4.1665 10.0003 4.1665C14.2545 4.1665 17.0461 7.92054 17.9839 9.40552C18.0974 9.58522 18.1541 9.67507 18.1859 9.81366C18.2098 9.91775 18.2098 10.0819 18.1859 10.186C18.1541 10.3246 18.0974 10.4145 17.9839 10.5942C17.0461 12.0791 14.2545 15.8332 10.0003 15.8332C5.74617 15.8332 2.95461 12.0791 2.01677 10.5942Z" stroke="#344054" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                                  <path d="M10.0003 12.4998C11.381 12.4998 12.5003 11.3805 12.5003 9.99984C12.5003 8.61913 11.381 7.49984 10.0003 7.49984C8.61962 7.49984 7.50034 8.61913 7.50034 9.99984C7.50034 11.3805 8.61962 12.4998 10.0003 12.4998Z" stroke="#344054" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Preview
                              </button>
                            }
                            {isPublishedOpen && ! isHomepage && ! isContactpage ? (
                              <div className="publishedButtonsList">
                                <ul>
                                  <li className="publish-li"

                                    onClick={(e) => {
                                      draftValidateFields();
                                      if (dbPageTitle.length > 0) {
                                        handleChangeToDraft();
                                      }
                                    }}>Change to draft</li>
                                  <li className="publish-li" onClick={handelSingleDelete}>Delete</li>
                                </ul>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>

                          {published === true ?
                            <p className="publishStatus">
                              <>Status: <span>{status}</span></>
                            </p>
                            :
                            ''
                          }
                        </div>
                      ) : (''

                      )}

                      {draft === true ? (
                        <div>
                          <div className="newpageRightButtons" ref={dotsRef}>
                            <button className="updateDraftButton primary-button minwidthAuto button" onClick={(e) => {
                              draftValidateFields();
                              if (dbPageTitle.length > 0) {
                                handleDraft(e)
                              }
                              }}>
                              {isLoading ?
                                <div className="updateDraftbutton-loader">
                                  <div className="ring-loader"></div>
                                </div>
                                :
                                <>
                                  <p>Update Draft</p>
                                </>}
                            </button>
                            <button
                              className="newpageMoreButtons button secondary-button minwidthAuto"
                              onClick={(e) => setIsDraftOpen(!isDraftOpen)}
                            >
                              <img src={dots} alt="Dots" className="action-dots" />
                            </button>
                            {
                              isPreviewLoading ? 
                              <div className="previewButtonLoader">
                                <div className="ring-loader cancel"></div>
                              </div> 
                              : 
                              <button className={`secondary-button minwidthAuto ${((isHomepage || isContactpage) && pageImage !== '') || 
                                (!isHomepage && !isContactpage && dbPageTitle.length > 0 && 
                                  ((editorContent?.length > 0) || (updatedContent?.length > 0)) && pageImage !== '')  ? 'preview-btn  previewTooltipblock button' : 'preview-btn  previewTooltipblock preview-disabled'}`} onClick={() => { showPreview() }} onMouseEnter={() => {
                                if (isFormInvalid) {
                                  setPreviewErrorMessage("Please fill in all the required fields to preview");
                                }
                              }}
                              onMouseLeave= {() => {
                                setPreviewErrorMessage("");
                              }}>
                                {previewErrorMessage !== "" && <div className='text-tooltip'>{previewErrorMessage}</div>}
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.01677 10.5942C1.90328 10.4145 1.84654 10.3246 1.81477 10.186C1.79091 10.0819 1.79091 9.91775 1.81477 9.81366C1.84654 9.67507 1.90328 9.58522 2.01677 9.40552C2.95461 7.92054 5.74617 4.1665 10.0003 4.1665C14.2545 4.1665 17.0461 7.92054 17.9839 9.40552C18.0974 9.58522 18.1541 9.67507 18.1859 9.81366C18.2098 9.91775 18.2098 10.0819 18.1859 10.186C18.1541 10.3246 18.0974 10.4145 17.9839 10.5942C17.0461 12.0791 14.2545 15.8332 10.0003 15.8332C5.74617 15.8332 2.95461 12.0791 2.01677 10.5942Z" stroke="#344054" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                                  <path d="M10.0003 12.4998C11.381 12.4998 12.5003 11.3805 12.5003 9.99984C12.5003 8.61913 11.381 7.49984 10.0003 7.49984C8.61962 7.49984 7.50034 8.61913 7.50034 9.99984C7.50034 11.3805 8.61962 12.4998 10.0003 12.4998Z" stroke="#344054" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Preview
                              </button>
                            }
                            {isDraftOpen ? (
                              <div className="publishedButtonsList">
                                <ul>
                                  <li className="publish-li" onClick={(e) => {
                                    validateFields();
                                    if (dbPageTitle.length > 0 && ((editorContent.length > 0) || (updatedContent.length > 0)) && pageImage !== '') {
                                      handleChangeToPublish(e, () => setIsLoading(true))
                                    }
                                  }}>Publish</li>
                                  <li className="publish-li" onClick={handelSingleDelete}>Delete</li>
                                </ul>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>

                          {draft === true ? (
                            <p className="publishStatus">
                              Status: <span className="draftStatus">Draft</span>
                            </p>
                          ) : (
                            ''
                          )}
                        </div>
                      ) : ''}
                    </div>

                    <div className="newPageRightRow">
                      <p className="newPageRightTitle iconDropWrap" onClick={toggleDropdown1}>
                        <span>
                          URL address
                        </span>
                        <div className="dropdownIcon">
                          <img src={iconDropDown} alt="dropdown" />
                        </div>
                      </p>
                      <div className={`contentDrop ${isOpen1 ? 'expanded' : 'collapse'}`}>
                        <p className="newPageRightFullUrl">
                          <span>Display at the end of the publication...</span>
                        </p>
                        <div className="adressInputBlock">
                          <img className="adressLink" src={link} alt="Link" />
                          <input
                            id="page-slug"
                            type="text"
                            placeholder="URL"
                            readOnly={isHomepage || isContactpage ? true : false}
                            value={isHomepage ? 'home' : url}
                            onChange={(e) => {
                              if( isHomepage || isContactpage ) {
                                return false;
                              }
                              props?.setContentChange(true)
                              setHasUnsavedChanges(true); 
                              setUrl(e.target.value);
                              setIslugChanged(true)
                              if (e.target.value === '') {
                                setIslugChanged(false)
                              }
                            }}
                            onBlur={(e) => {
                              if( isHomepage || isContactpage ) {
                                return false;
                              }
                              let urlValue = convertToSlug(e.target.value);
                              setUrl(urlValue);
                              if (e.target.value === '') {
                                changeSlug(pageTitle);
                                setIslugChanged(false)
                              }
                            }}
                          />
                        </div>
                        <p className="newPageRightFullUrl slug-box">
                          Full URL:
                          {
                            published === true && status == 'Published' ? (
                              <Link className="pageurl" target={'_blank'} to={`${baseUrl}${url}`}>
                                <span>{baseUrl}{url}</span>
                                <img className="link-external" src={linkExternal} />
                              </Link>
                            ) : (
                              <>
                                {
                                    (customDomain?.verified && customDomain?.domainName !== "") ? 
                                    <span className="pageurl">
                                      {customDomain?.domainName}
                                    </span>
                                    :
                                    <span className="pageurl">{baseUrl}{url}</span>
                                  }
                              </>
                            )
                          }
                        </p>
                      </div>
                    </div>

                    { ! isHomepage && ! isContactpage &&
                      <div className="newPageRightRow categoryFieldDrop">
                        <p className="newPageRightTitle iconDropWrap" onClick={toggleDropdown4}>
                            <span>Categories (optional)</span>
                            <div className="dropdownIcon">
                              <img src={iconDropDown} alt="dropdown" />
                            </div>
                        </p>

                        <div className={`contentDrop ${isOpen4 ? 'expanded' : 'collapse'}`}>
                            <p className="newPageRightFullUrl">
                              <span>Display at the end of the publication...</span>
                            </p>
                            <div className="adressInputBlock urlInput">
                              <img className="adressLink" src={search} alt="Search" />
                              <input
                                type="text"
                                placeholder="Search"
                                value={searchCategory}
                                onChange={(e) => setSearchCategory(e.target.value)}
                                onKeyPress={handleKeyPress}
                              />
                              <ul className="list-search categories-list">
                                {
                                  filteredValues
                                    .filter((category) => category.toLowerCase().includes(searchCategory.toLowerCase()))
                                    .map((category, index) => (
                                      <li key={index}>
                                        <label>
                                          <input 
                                            type="checkbox"
                                            checked={selectedCategories.includes(category)}
                                            onChange={() => handleCheckboxChange(category)}
                                          />
                                          <p>{category}</p>
                                        </label>
                                      </li>
                                    ))
                                }
                              </ul> 
                              
                              <button className="new-category" onClick={handleNewCategoryClick}>
                                <img src={plus} alt="Plus" /> New Category
                              </button>
                          </div>
                        </div>
                      </div>
                    }

                    <div className="newPageRight desktopFeatures">
                      <p className="newPageRightTitle iconDropWrap" onClick={toggleDropdown3}>
                        <span>
                        Featured image
                        </span>
                        <div className="dropdownIcon">
                          <img src={iconDropDown} alt="dropdown" />
                        </div>
                      </p>
                      <div className={`contentDrop ${isOpen3 ? 'expanded' : 'collapse'}`}>
                      <p className="newPageRightFullUrl">
                        <span>Display at the end of the publication...</span>
                      </p>
                      <div
                        className="newPageRightRow imageUploadBox"
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                      >
                        {saveFeatureImage ? (
                          <div
                            id="newpageImageUpload"
                            className={ isDragging ? "draging newpageImageUpload" : "newpageImageUpload" }
                            onClick={handleClick}
                          >
                            {loadingFeatureImg === true &&
                              featuredImageModal == false ? (
                              <div className="featureImg-loader">
                                <Loader />
                              </div>
                            ) : (
                              <>
                                <div onClick={handleClick}>
                                  <img
                                    className="newpage_CoverImg"
                                    src={featureImage}
                                    onLoad={handleImageLoad}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        ) : (
                          <div
                            id="newpageImageUpload"
                            className={ isDragging ? "draging newpageImageUpload" : "newpageImageUpload" }
                            onClick={() => {
                              setShowUploadMediaPopup(true);
                              setUploadMediaPopupFor('feature-image');
                              setUploadMediaPopupTab('upload');
                            }}
                          >
                            {loadingFeatureImg === true &&
                              featuredImageModal === false ? (
                              <div className="featureImg-loader">
                                <Loader />
                              </div>
                            ) : (
                              <div className="featureImgMiddleContent">
                                <img
                                  className="fileUploadCover_Img"
                                  src={featured}
                                  alt="Featured Image"
                                />
                                <p className="newPageImageUploadText">                                
                                  <span>Upload</span> or <span onClick={(e) => {e.stopPropagation(); setShowUploadMediaPopup(true); setUploadMediaPopupFor('feature-image'); setUploadMediaPopupTab('media');}}>Open Media Library</span>
                                    <br />
                                    JPG, PNG (max. 128MB)
                                </p>
                              </div>
                            )}
                          </div>
                        )}
                        <input
                          type="file"
                          id="feature-img"
                          ref={fileInputRef}
                          onChange={(e) => {
                            handleFileUpload(e);
                            setValidateImage(false);
                          }}

                          accept="image/*"
                          hidden
                        />
                      </div>
                      {validateImage === true ? (
                        <p className="validateError">{( isHomepage || isContactpage ) ? "Please select a featured image" : 'Please choose a featured image'}</p>
                      ) : (
                        ""
                      )}
                       <input
                          type="text"
                          className="img-captions"
                          placeholder="Image caption (optional)"
                          value={imageCaption}
                          onChange={(e) => { setimageCaption(e.target.value); props?.setContentChange(true); setHasUnsavedChanges(true);  }}
                        />
                      </div>
                    
                    </div>
                    <div className="buttonsMobile">

                      {(published === false && draft === false) ?
                        <div className="newpageRightButtons publish-button">
                          <button
                            className="primary-button minwidthAuto button"
                            onClick={async (e) => {
                              validateFields();
                              if (dbPageTitle.length > 0 && ((editorContent.length > 0) || (updatedContent.length > 0)) && pageImage !== '') {
                                setIsLoading(true);
                                await addData(true, "Published");
                                setOpenNotify(true);
                                setPublished(true);
                                setPublicationList([...publicationList, { title: "Published" }]);

                                clearTimeout(notificationTimeoutId) 
                                notificationTimeoutId = setTimeout(() => {
                                  setOpenNotify(false)
                                }, 10000);
                              }
                            }
                            }
                          >
                            {isLoading ?
                              <div className="publishbutton-loader">
                                <div className="ring-loader"></div>
                              </div>
                              :
                              <>
                                <img className="publish-arrow" src={send} alt="Send" />
                                <p>Publish</p>
                              </>}
                          </button>
                          <button className="secondary-button minwidthAuto draft-button"
                            onClick={async (e) => {
                              draftValidateFields();
                              if (dbPageTitle.length > 0) {
                                setIsDraftLoading(true);
                                await addData(true, "Draft");
                                setDraft(true);
                                setDraftNotify(true);
                              }
                            }}>
                            {isDraftLoading ?
                              <div className="draftButton-loader">
                                <div className="ring-loader cancel"></div>
                              </div>
                              :
                              <>
                                Save as draft
                              </>}
                          </button>
                          {
                            isPreviewLoading ? 
                            <div className="previewButtonLoader">
                              <div className="ring-loader cancel"></div>
                            </div> 
                            : 
                            <button className={`secondary-button minwidthAuto ${((isHomepage || isContactpage) && pageImage !== '') || 
                              (!isHomepage && !isContactpage && dbPageTitle.length > 0 && 
                                ((editorContent?.length > 0) || (updatedContent?.length > 0)) && pageImage !== '') ? 'preview-btn  previewTooltipblock  minwidthAuto button' : 'preview-btn  previewTooltipblock preview-disabled'}`} onClick={() => { showPreview() }} onMouseEnter={() => {
                              if (isFormInvalid) {
                                setPreviewErrorMessage("Please fill in all the required fields to preview");
                              }
                            }}
                            onMouseLeave= {() => {
                              setPreviewErrorMessage("");
                            }}>
                              {previewErrorMessage !== "" && <div className='text-tooltip'>{previewErrorMessage}</div>}
                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.01677 10.5942C1.90328 10.4145 1.84654 10.3246 1.81477 10.186C1.79091 10.0819 1.79091 9.91775 1.81477 9.81366C1.84654 9.67507 1.90328 9.58522 2.01677 9.40552C2.95461 7.92054 5.74617 4.1665 10.0003 4.1665C14.2545 4.1665 17.0461 7.92054 17.9839 9.40552C18.0974 9.58522 18.1541 9.67507 18.1859 9.81366C18.2098 9.91775 18.2098 10.0819 18.1859 10.186C18.1541 10.3246 18.0974 10.4145 17.9839 10.5942C17.0461 12.0791 14.2545 15.8332 10.0003 15.8332C5.74617 15.8332 2.95461 12.0791 2.01677 10.5942Z" stroke="#344054" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M10.0003 12.4998C11.381 12.4998 12.5003 11.3805 12.5003 9.99984C12.5003 8.61913 11.381 7.49984 10.0003 7.49984C8.61962 7.49984 7.50034 8.61913 7.50034 9.99984C7.50034 11.3805 8.61962 12.4998 10.0003 12.4998Z" stroke="#344054" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              Preview
                            </button>
                          }
                        </div>
                        :
                        ''}

                      {published === true ? (
                        <div>
                          <div className="newpageRightButtons" ref={dotsRef}>
                            <button className="primary-button button updatePagebtn" onClick={(e) => {
                              validateFields();
                              if (dbPageTitle.length > 0 && ((updatedContent?.trim().length > 0 || editorContent?.trim().length > 0)) && pageImage !== '') {
                                handlePublish(e)
                              }
                              if( isHomepage && ((updatedContent?.trim().length > 0 || editorContent?.trim().length > 0)) && pageImage !== '' ) {
                                handlePublish(e)
                              }
                              if( isContactpage && pageImage !== '' ) {

                                if( validationContactpageData.publicEmailValid && validationContactpageData.receiveEmailValid && validationContactpageData.publicaPhoneValid ) {
                                  handlePublish(e);
                                } else {
                                  setValidationContactpageData((prevState) => ({
                                      ...prevState, // Spread the previous state
                                      showError: true // Update showError with the new value
                                  }));
                                }
                              }
                            }}>
                              {isLoading ?
                                <div className="updatebutton-loader">
                                  <div className="ring-loader"></div>
                                </div>
                                :
                                <>
                                  <p>Update</p>
                                </>}
                            </button>
                            <button
                              className="newpageMoreButtons button secondary-button minwidthAuto"
                              onClick={(e) => setIsPublishedOpen(!isPublishedOpen)}
                            >
                              <img src={dots} alt="Dots" />
                            </button>
                            {
                              isPreviewLoading ? 
                              <div className="previewButtonLoader">
                                <div className="ring-loader cancel"></div>
                              </div> 
                              : 
                              <button className={`secondary-button minwidthAuto ${((isHomepage || isContactpage) && pageImage !== '') || 
                                (!isHomepage && !isContactpage && dbPageTitle.length > 0 && 
                                  ((editorContent?.length > 0) || (updatedContent?.length > 0)) && pageImage !== '') ? 'preview-btn  previewTooltipblock button' : 'preview-btn  previewTooltipblock preview-disabled'}`} onClick={() => { showPreview() }} onMouseEnter={() => {
                                if (isFormInvalid) {
                                  setPreviewErrorMessage("Please fill in all the required fields to preview");
                                }
                              }}
                              onMouseLeave= {() => {
                                setPreviewErrorMessage("");
                              }}>
                                {previewErrorMessage !== "" && <div className='text-tooltip'>{previewErrorMessage}</div>}
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.01677 10.5942C1.90328 10.4145 1.84654 10.3246 1.81477 10.186C1.79091 10.0819 1.79091 9.91775 1.81477 9.81366C1.84654 9.67507 1.90328 9.58522 2.01677 9.40552C2.95461 7.92054 5.74617 4.1665 10.0003 4.1665C14.2545 4.1665 17.0461 7.92054 17.9839 9.40552C18.0974 9.58522 18.1541 9.67507 18.1859 9.81366C18.2098 9.91775 18.2098 10.0819 18.1859 10.186C18.1541 10.3246 18.0974 10.4145 17.9839 10.5942C17.0461 12.0791 14.2545 15.8332 10.0003 15.8332C5.74617 15.8332 2.95461 12.0791 2.01677 10.5942Z" stroke="#344054" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                                  <path d="M10.0003 12.4998C11.381 12.4998 12.5003 11.3805 12.5003 9.99984C12.5003 8.61913 11.381 7.49984 10.0003 7.49984C8.61962 7.49984 7.50034 8.61913 7.50034 9.99984C7.50034 11.3805 8.61962 12.4998 10.0003 12.4998Z" stroke="#344054" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Preview
                              </button>
                            }
                            {isPublishedOpen && ! isHomepage && ! isContactpage ? (
                              <div className="publishedButtonsList">
                                <ul>
                                  <li className="publish-li" onClick={handleChangeToDraft}>Change to draft</li>
                                  <li className="publish-li" onClick={handelSingleDelete}>Delete</li>
                                </ul>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          {published === true ? (
                            <p className="publishStatus">
                              Status: <span>{status}</span>
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}

                      {draft === true ? (
                        <div>
                          <div className="newpageRightButtons" ref={dotsRef}>
                            <button className="updateDraftButton primary-button minwidthAuto button" onClick={(e) => {
                              draftValidateFields();
                              if (dbPageTitle.length > 0) {
                                handleDraft(e)
                              }
                            }}>
                              {isLoading ?
                                <div className="updateDraftbutton-loader">
                                  <div className="ring-loader"></div>
                                </div>
                                :
                                <>
                                  <p>Update Draft</p>
                                </>}
                            </button>
                            <button
                              className="newpageMoreButtons button secondary-button minwidthAuto"
                              onClick={(e) => setIsDraftOpen(!isDraftOpen)}
                            >
                              <img src={dots} alt="Dots" className="action-dots" />
                            </button>
                            {
                              isPreviewLoading ? 
                              <div className="previewButtonLoader">
                                <div className="ring-loader cancel"></div>
                              </div> 
                              : 
                              <button className={`minwidthAuto ${((isHomepage || isContactpage) && pageImage !== '') || 
                                (!isHomepage && !isContactpage && dbPageTitle.length > 0 && 
                                  ((editorContent?.length > 0) || (updatedContent?.length > 0)) && pageImage !== '') ? 'preview-btn  previewTooltipblock secondary-button button' : ' preview-btn previewTooltipblock preview-disabled secondary-button'}`} onClick={() => { showPreview() }} onMouseEnter={() => {
                                if (isFormInvalid) {
                                  setPreviewErrorMessage("Please fill in all the required fields to preview");
                                }
                              }}
                              onMouseLeave= {() => {
                                setPreviewErrorMessage("");
                              }}>
                                {previewErrorMessage !== "" && <div className='text-tooltip'>{previewErrorMessage}</div>}
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.01677 10.5942C1.90328 10.4145 1.84654 10.3246 1.81477 10.186C1.79091 10.0819 1.79091 9.91775 1.81477 9.81366C1.84654 9.67507 1.90328 9.58522 2.01677 9.40552C2.95461 7.92054 5.74617 4.1665 10.0003 4.1665C14.2545 4.1665 17.0461 7.92054 17.9839 9.40552C18.0974 9.58522 18.1541 9.67507 18.1859 9.81366C18.2098 9.91775 18.2098 10.0819 18.1859 10.186C18.1541 10.3246 18.0974 10.4145 17.9839 10.5942C17.0461 12.0791 14.2545 15.8332 10.0003 15.8332C5.74617 15.8332 2.95461 12.0791 2.01677 10.5942Z" stroke="#344054" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                                  <path d="M10.0003 12.4998C11.381 12.4998 12.5003 11.3805 12.5003 9.99984C12.5003 8.61913 11.381 7.49984 10.0003 7.49984C8.61962 7.49984 7.50034 8.61913 7.50034 9.99984C7.50034 11.3805 8.61962 12.4998 10.0003 12.4998Z" stroke="#344054" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Preview
                              </button>
                            }

                            {isDraftOpen ? (
                              <div className="publishedButtonsList">
                                <ul>
                                  <li className="publish-li" onClick={(e) => {
                                    validateFields();
                                    if (dbPageTitle.length > 0 && ((updatedContent?.trim().length > 0 || editorContent?.trim().length > 0)) && pageImage !== '') {
                                      handleChangeToPublish(e, () => setIsLoading(true))
                                    }
                                  }}>Publish</li>
                                  <li className="publish-li" onClick={handelSingleDelete}>Delete</li>
                                </ul>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>

                          <p className="publishStatus">
                            Status: <span className="draftStatus">Draft</span>
                          </p>
                        </div>
                      ) : (
                        ""
                      )}

                    </div>
                  </div>
                </div>
              </div>
            </div>

            { (openPagePopup && status === 'Published') && (
                <>
                    <div className="welcomeOverlay previewOverlay"></div>
                    <PreviewPopup setShowPreviewPopup={setOpenPagePopup} showPreviewPopup={openPagePopup} previewpage={"Page"} tempData={popupData} userMetaData={props.userMetaData} profileSlug={profileSlug} inputUrl={baseUrl}/>
                </>
            )}
            
            {showUploadMediaPopup && 
              <UploadMediaPopup showUploadMediaPopup={showUploadMediaPopup} setShowUploadMediaPopup={setShowUploadMediaPopup} setSelectedProfileImage={setSelectedFeatureImage} selectMediaLoading={selectMediaLoading} uploadMediaPopupFor={uploadMediaPopupFor} uploadMediaPopupTab={uploadMediaPopupTab}/>
            }
            {(isPopupOpenDeleteAccount || showCategoryField) && <div className="welcomeOverlay"></div>}
            <SingleDeletePage isOpen={isPopupOpenDeleteAccount} onClose={closeAccountDeletedPopup} type="page" name="pages" data={data} index={[newPageID]} action="action" setShowNotification={setShowNotification} setContentChange={props?.setContentChange}/>
            <AddCategoryPage isOpen={showCategoryField} onClose={closeCategoryField} data={values} setCategory={setCategories} setSelectedCategory={setSelectedCategories} setOpenNotify={setCategoriesNotify} />

            {categoriesNotify && 
              <NotificationMessage  openNotify={categoriesNotify} setOpenNotify={setCategoriesNotify} type={'success'} title={`Category has been successfully added!`} />
            }
            {featuredImageModal && (
              <>
                <div className="imagCropModal"  id="deleteMedia">
                  <div className="featuredImageModal featurboxModal" ref={modalRef}>
                    <div className="modal-content">
                      {uploadedImage === null ? (
                        <div
                          className="newPageRightRow"
                          onDragOver={handleDragOver}
                          onDragLeave={handleDragLeave}
                          onDrop={handleDrop}
                        >
                          {((saveFeatureImage && saveFeatureImage === oldImage) ||
                            saveFeatureImage !== featureImage) &&
                            (saveFeatureImage ? (
                              <div
                                id="newpageImageUpload"
                                className={ isDragging ? "draging newpageImageUpload" : "newpageImageUpload"
                                }
                              >
                                {loadingFeatureImg === true ? (
                                  <div className="featureImg-loader">
                                    <Loader />
                                  </div>
                                ) : (
                                  <>
                                    <div>
                                      <div className="crop-container">
                                        <ImageEditor
                                          type="featureImg"
                                          image={featureImage}
                                          oldImage={oldImage}
                                          setOldImage={setOldImage}
                                          setFeatureImage={setFeatureImage}
                                          setUploadedImage={setUploadedImage}
                                          replaceImage={handleFileUpload}
                                          zoom={zoom}
                                          position={position}
                                          setZoom={handleZoom}
                                          setPosition={handlePosition}
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            ) : (
                              <div
                                id="newpageImageUpload"
                                className={ isDragging ? "draging newpageImageUpload" : "newpageImageUpload" }
                                onClick={() =>{
                                  setShowUploadMediaPopup(true);
                                  setUploadMediaPopupFor('feature-image');
                                  setUploadMediaPopupTab('upload');
                                }}
                              >
                                {loadingFeatureImg === true ? (
                                  <div className="featureImg-loader">
                                    <Loader />
                                  </div>
                                ) : (
                                  <>
                                    <div className="featureImgMiddleContent">
                                      <img
                                        className="fileUploadCover_Img"
                                        src={featured}
                                        alt="Featured Image"
                                      />
                                      <p className="newPageImageUploadText">                                      
                                        <span>Upload</span> or <span onClick={(e) => {e.stopPropagation(); setShowUploadMediaPopup(true); setUploadMediaPopupFor('feature-image'); setUploadMediaPopupTab('media');}}>Open Media Library</span>
                                        <br />
                                        JPG, PNG (max. 128MB)
                                      </p>
                                    </div>
                                  </>
                                )}
                              </div>
                            ))}

                          {featureImage &&
                            saveFeatureImage === featureImage &&
                            (featureImage ? (
                              <div
                                id="newpageImageUpload"
                                className={ isDragging ? "draging newpageImageUpload" : "newpageImageUpload"
                                }
                              >
                                {loadingFeatureImg === true ? (
                                  <div className="featureImg-loader">
                                    <Loader />
                                  </div>
                                ) : (
                                  <>
                                    <div>
                                      <div className="crop-container">
                                        <ImageEditor
                                          type="featureImg"
                                          image={featureImage}
                                          oldImage={oldImage}
                                          setOldImage={setOldImage}
                                          setFeatureImage={setFeatureImage}
                                          setUploadedImage={setUploadedImage}
                                          replaceImage={handleFileUpload}
                                          zoom={zoom}
                                          position={position}
                                          setZoom={handleZoom}
                                          setPosition={handlePosition}
                                        />
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            ) : (
                              <div
                                id="newpageImageUpload"
                                className={ isDragging ? "draging newpageImageUpload" : "newpageImageUpload" }
                                onClick={() =>{                                  
                                  setShowUploadMediaPopup(true);
                                  setUploadMediaPopupFor('feature-image');
                                  setUploadMediaPopupTab('upload');
                                }}
                              >
                                {loadingFeatureImg === true ? (
                                  <div className="featureImg-loader">
                                    <Loader />
                                  </div>
                                ) : (
                                  <>
                                    <div className="featureImgMiddleContent">
                                      <img
                                        className="fileUploadCover_Img"
                                        src={featured}
                                        alt="Featured Image"
                                      />
                                      <p className="newPageImageUploadText">
                                        <span>Upload</span> or <span onClick={(e) => {e.stopPropagation(); setShowUploadMediaPopup(true); setUploadMediaPopupFor('feature-image'); setUploadMediaPopupTab('media');}}>Open Media Library</span>
                                        <br />
                                        JPG, PNG (max. 128MB)
                                      </p>
                                    </div>
                                  </>
                                )}
                              </div>
                            ))}
                          <input
                            type="file"
                            id="feature-img"
                            onChange={handleFileUpload}
                            accept="image/*"
                            hidden
                          />
                        </div>
                      ) : (
                        <div>
                          <div className="crop-container">
                            {featureImage && oldImage && (
                              <ImageEditor
                                type="featureImg"
                                image={featureImage}
                                oldImage={oldImage}
                                setFeatureImage={setFeatureImage}
                                setUploadedImage={setUploadedImage}
                                replaceImage={handleFileUpload}
                                zoom={zoom}
                                position={position}
                                setZoom={handleZoom}
                                setPosition={handlePosition}
                              />
                            )}
                          </div>
                        </div>
                      )}
                      <div className="replaceImageRange">
                        <div className="replaceImgBtn">
                          <button
                            className="uploadImage button"
                            type="button"
                            onClick={() => handleReplaceImg()}
                          >
                            <span>Replace Image</span>
                          </button>
                        </div>
                        <div className="imgRange">
                          <img className="coverImgLeft" src={coverImg} />
                          <input
                            id="zoom-range"
                            className="zoom-range"
                            type="range"
                            onMouseDown={handleMouseDown}
                            onMouseUp={handleMouseUp}
                            onTouchStart={handleTouchStart}
                            onTouchEnd={handleTouchEnd}
                            value={zoom}
                            min={1}
                            max={3}
                            step={0.1}
                            aspect={384 / 200}
                            aria-labelledby="Zoom"
                            style={{
                              background: `linear-gradient(to right, #344054 ${((zoom - 1) / 2) * 100
                                }%, #B7BCC2 0%)`,
                            }}
                            onChange={(e) => {
                              handleZoom(e.target.value);
                            }}
                          />
                          <img className="coverImgRight" src={coverImg} />
                        </div>
                      </div>
                      <div className="featuredImageModalbtn">
                        <button
                          className="cancel button"
                          type="button"
                          onClick={() => handleCancel()}
                        >
                          Cancel
                        </button>
                        <button
                          className="savePicture primary-button button"
                          type="button"
                          onClick={() => handleSavePicture()}
                        >
                          Save Picture
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {featuredImageModal && <div className="overlayModal"> </div>}
              </>
            )}
            {
              <Notification
                title={"Your page has been successfully updated! "}
                text={"You can view it"}
                link= {"here."}
                to={`/dashboard/page/${newPageID}`}
                setOpenNotify={setOpenNotifyDraft}
                type={"success"}
                openNotify={openNotifyDraft}
              />
            }
            { ! openPagePopup && 
                <Notification
                  title={"Your page has been successfully published!"}
                  text={"You can view it "}
                  link= {"here."}
                  to={(customDomain?.verified && customDomain?.domainName !== "") ? `${customDomain?.domainName}/${popupData?.url_address}` :`https://jourmal-next-front.vercel.app/${profileSlug}/${popupData?.url_address}`}
                  setOpenNotify={setOpenNotify}
                  type={"success"}
                  openNotify={openNotify}
                />
            }
            {draftNotify && 
              <NotificationMessage  openNotify={draftNotify} setOpenNotify={setDraftNotify} type={'success'} title={`Your page has been saved as a draft!`} />
            }
            {showNotification && (
                <NotificationMessage  openNotify={showNotification} setOpenNotify={setShowNotification} type={'success'} title={`The page was successfully deleted!`} />
            )}
          </section>
            :
              canChkAccess && <Error menuDisabled={true} />
      }
    </>
  );
}

export default NewPage;
